import mapboxgl from 'mapbox-gl'
import { useState } from 'react'

import { IAPI } from 'src/api'

import { addDockedBikes } from '../dockedBikes'
import { DockedStationEnum } from '../LayersPopup'
import { IGBFSDataResponse, ISelectedStation } from '../types'
import { fetchGBFS, toggleGBFSLayersVisibility } from '../utils'

interface IUseHandleGBFSDataProps {
  api: IAPI
  map?: mapboxgl.Map
  onMouseEnter: () => void
  onMouseLeave: () => void
  setSelectedStation: (station: ISelectedStation | undefined) => void
}

export function useHandleGBFSData({
  api,
  map,
  onMouseEnter,
  onMouseLeave,
  setSelectedStation,
}: IUseHandleGBFSDataProps) {
  const [gbfsData, setGbfsData] = useState<IGBFSDataResponse | undefined>(undefined)

  const loadGBFSData = async (mapInstance?: mapboxgl.Map) => {
    const targetMap = mapInstance || map
    if (!targetMap || gbfsData) {
      return
    }

    const gbfsResponse = await fetchGBFS(api)
    setGbfsData(gbfsResponse)
    await addDockedBikes(targetMap, onMouseEnter, onMouseLeave, setSelectedStation, gbfsResponse)
    return gbfsResponse
  }

  const toggleGBFSLayers = async (layers: DockedStationEnum[], mapInstance?: mapboxgl.Map) => {
    const targetMap = mapInstance || map
    if (!targetMap) {
      return
    }

    if (layers.length > 0) {
      if (gbfsData) {
        toggleGBFSLayersVisibility(layers, gbfsData, targetMap)
      } else {
        const gbfsResponse = await loadGBFSData(mapInstance)
        if (gbfsResponse) {
          toggleGBFSLayersVisibility(layers, gbfsResponse, targetMap)
        }
      }
    } else if (gbfsData) {
      toggleGBFSLayersVisibility([], gbfsData, targetMap)
    }
  }

  return { gbfsData, loadGBFSData, toggleGBFSLayers }
}
